import { PatientTreatmentsEligibility } from './PatientTreatmentsEligibility'
export default PatientTreatmentsEligibility